export default __webpack_public_path__ + "static/media/Birthday.76a409fb.svg";